module.exports = __webpack_public_path__ + "img/cms-for-tablets-code.a7cc9ffd.png";